import { Typography } from "antd";

interface Props {
  title: string;
  variant?: number;
  width?: number;
}

export const Title = ({ title, variant, width = 460 }: Props) => {
  return (
    <>
      <div
        style={{
          height: 4,
          width: 80,
          background: "#00B8F5",
          // marginBottom: 10,
        }}
      ></div>
      <div style={{ display: "flex", alignItems : "center", marginBottom: 20 }}>
        <div style={{ width: width }}>
          <div
            className="textTitle clr-secondary"
            style={{ marginBottom: 0, marginRight: 20 }}
          >
            {title}
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <div
            style={{
              border: variant === 2 ? "1px solid #003087" : "1px solid #FFFFFF",
              height: 0,
              width: "100%",
            }}
          ></div>
        </div>
      </div>
    </>
  );
};
